module.exports = __webpack_public_path__ + "img/avatar3.e1e8c48b.jpg";